import ModalEventController from "./modal_event_controller"

export default class extends ModalEventController {

  connect() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }
}